import i18n from '@/i18n';

const configFormTargetProduct = () => {
    return {
        configFieldTitleBlockTargetProduct: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('landingPage.settingTargetProduct.titleBlock'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['required', 'max255']
        },
        configFieldSizeTitle: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('landingPage.setSizeText'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max255']
        },
        configFieldDetailTargetProduct: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('landingPage.settingTargetProduct.detailTargetProduct'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max255']
        },
        configFieldLinkTargetProduct: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('landingPage.settingTargetProduct.linkTargetProduct'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['max255']
        }
    };
};

const configModalActionProduct = {
    id: '',
    title: '',
    model: false,
    scrollable: true,
    hideFooter: false,
    size: 'xl',
    class: 'h-100',
    validate: true
};

const STATUS_TARGET_PRODUCT = [
    {
        id: 1,
        value: true,
        name: '有効'
    },
    {
        id: 2,
        value: false,
        name: '無効'
    }
];

const configFormProductLP = {
    configFieldTitleProduct: {
        isNumber: false,
        isMaxLength: false,
        error: false,
        errorField: i18n.t('landingPage.settingPrize.titlePrize'),
        errorCustomMess: '',
        valueSync: '',
        typesValidate: ['required', 'max255']
    },
    configFieldSizeTitle: {
        isNumber: false,
        isMaxLength: false,
        error: false,
        errorField: i18n.t('landingPage.setSizeText'),
        errorCustomMess: '',
        valueSync: '',
        typesValidate: ['max255']
    }
};

export { configFormTargetProduct, configModalActionProduct, configFormProductLP, STATUS_TARGET_PRODUCT };
